// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"734327bd","134":"bd4ffd85","202":"3e5d45c8","213":"4c2d0fe7","442":"3d280a3c","453":"9782536d","455":"322ecdcf","483":"feaf4873","592":"14cef5ed","753":"3b1ed96b","857":"848da76e","925":"9f22dd11","992":"f5b1346f"}[chunkId] + ".chunk.js";
};